import styled from 'styled-components'

import { applyTextStyle } from '../../styles/typography'

const FilterGroupHeader = styled.div`
  padding: 12px 16px 6px;
  color: ${({ theme }) => theme.colors.textLight};
  ${applyTextStyle('labelSmallCaps')}
`

export default FilterGroupHeader
